module.exports = __webpack_public_path__ + "static/heart-mountain-25807bba6379c04d245ea264442988d2.jpg";